import React, { Component } from 'react';
import {connect} from "react-redux";


import './carAlbumPopup.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//components
import Slider from 'react-slick';

//assets
import attention from 'assets/icons/attention.svg';
import arrowRight from 'assets/icons/arrow_right_filled_blue.svg';
import close_icon from 'assets/icons/close_bug.svg';
import yellowBug from 'assets/icons/bug-yellow.svg';
import {getFullMediaUrl} from "../../../../app/static_func";
import Loader from "../../../common/loader/loader";


class Basic extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id,
            indoorPhotos: false,
            bugWindow: false,
            path: '',
            bugAnimation: false,
            bug_type: '',
            currentSlide: 0,
        };
        this.animateOut = this.animateOut.bind(this);
        this.animateIn = this.animateIn.bind(this);
        this.handleNavbarClick = this.handleNavbarClick.bind(this);
        this.handleBugClick = this.handleBugClick.bind(this);
        this.handleBugCloseClick = this.handleBugCloseClick.bind(this);
        this.getSlides = this.getSlides.bind(this);

        this.loadedPhotos = {};
        this.images_amount = 0;
        this.exteriors = 0;
        this.interiors = 0;

        //represents the last slide method
        this.lastMove = false;
    }

    static getDerivedStateFromProps(props, state) {
        if(props.popup_id !== state.popup_id) {
            return {animation_class: 'active'}
        }
        return {};
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
        const carDetails = this.props.carDetails[Object.keys(this.props.carDetails)[0]];

        carDetails.images.forEach(item => {
                this.images_amount ++;
                var myImg = new Image();

                myImg.onload = () => {
                    this.loadedPhotos[item.id] = (myImg);
                    this.forceUpdate();
                };
                myImg.src = getFullMediaUrl(item.image.path);

                if (item['car-frame-type'] === 'interior'){
                    this.interiors ++;
                }
                else{
                    this.exteriors ++;
                }
        });
        setInterval(()=>{
            this.setState({bugAnimation: !this.state.bugAnimation});
        },1000);

    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleNavbarClick(e){
        if(e.target.innerHTML.includes('פנימי'))
            this.setState({indoorPhotos:true});
        else
            this.setState({indoorPhotos:false});

    }

    handleBugClick(path, bug_type){
        console.log(bug_type);
        this.setState({bugWindow:true, path:path, bug_type: bug_type});
    }

    handleBugCloseClick(){
        this.setState({bugWindow:false, path: null});
    }

    getCarSlides(){
        return this.getSlides('exterior');
    }

    getInnerPhotos(){
        return this.getSlides('interior');
    }

    getSlides(type){
        let results = [];
        const carDetails = this.props.carDetails[Object.keys(this.props.carDetails)[0]];

        carDetails.images.forEach((item,index) => {
            if(item['car-frame-type'] === type) {
                results.push(
                    <div key={index} className={'photo_wrapper ' + (type === 'interior' ? 'interior' : '')}>
                        <img className='photo' src={getFullMediaUrl(item.image.path)} alt={item.image.alt}/>
                        {item.defects.map((curr,index) => {

                            //decreasing left coordinate due to server false math...
                            const style = {
                                top: (((curr.y / this.loadedPhotos[item.id].naturalHeight) * 100) + '%'),
                                left: ((((curr.x / this.loadedPhotos[item.id].naturalWidth) * 100)) + '%')
                            };

                            return (
                                <div key={index} className={'bug-hover ' + (this.state.bugAnimation ? 'on' : '')}>
                                    <img className='bug' src={attention}
                                         alt='/'
                                         style={style}
                                         onClick={() => this.handleBugClick(getFullMediaUrl(curr.image.path),curr.defect_title)}
                                    />
                                    <img className='bug yellow' src={yellowBug}
                                         alt='/'
                                         style={style}
                                         onClick={() => this.handleBugClick(getFullMediaUrl(curr.image.path),curr.defect_title)}
                                    />
                                </div>
                            )
                        })}
                    </div>
                )
            }
        });
        return results;
    }

    handleSlideChange = (prev, next) =>{

        //if the last slide was via swipe or arrow, than the algorithm will check if indoor slides needs to be shown
        if (this.lastMove) {
            if ((prev + 1) === this.exteriors && next === 0) {
                this.setState({indoorPhotos: true});
            } else if ((prev === 0) && (next + 1) === this.exteriors) {
                this.setState({indoorPhotos: true});
            }
        }

        this.lastMove = false;
    };


    //extra event listener to arrows click
    handleArrowMove = () =>{
        this.lastMove = true;
    };


    render() {
        const isMobileOrTablet = this.props.deviceState === 'mobile' || this.props.deviceState === 'tablet';

        const settingsMobile ={
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            rtl:false,
            arrows:false,
            beforeChange: (prev,next) => this.handleSlideChange(prev,next),
            onSwipe: () =>{this.lastMove = true;},
        };

        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            rtl:false,
            arrows:true,
            customPaging:function (i) {
                return(<button>{i+1}</button>)
            },
            nextArrow:<NextArrow onArrowMove={this.handleArrowMove}/>,
            prevArrow:<PrevArrow onArrowMove={this.handleArrowMove}/>,
            beforeChange: (prev,next) => this.handleSlideChange(prev,next),
            onSwipe: () =>{this.lastMove = true;}
        };

        const carDetails = this.props.carDetails[Object.keys(this.props.carDetails)[0]];

        return (
            <div className = { "backdrop carAlbum " + this.state.animation_class } onClick = { () => this.animateOut() }>
                {carDetails && Object.keys(this.loadedPhotos).length === this.images_amount && this.images_amount > 0 &&
                <div className={"popup_wrapper " + this.state.animation_class} onClick={(e) => e.stopPropagation()}>
                    <button className="x_close_icon" onClick={() => this.animateOut()}/>
                    <div className='navbar'>
                        <button className={'nav_btn ' + (this.state.indoorPhotos ? '' : 'selected')}
                                onClick={e => this.handleNavbarClick(e)}>חיצוני ({this.exteriors})
                        </button>
                        <div className='divider'/>
                        <button className={'nav_btn ' + (this.state.indoorPhotos ? 'selected' : '')}
                                onClick={e => this.handleNavbarClick(e)}>פנימי ({this.interiors})
                        </button>
                    </div>
                    <Slider ref={c => this.slider = c} className={'album'} {...(isMobileOrTablet ? settingsMobile : settings)} >
                        {(this.state.indoorPhotos ? this.getInnerPhotos() : this.getCarSlides())}
                    </Slider>
                    <div className={'bug_window ' + (this.state.bugWindow ? 'open' : '')}
                         onClick={()=> this.setState({bugWindow:false,path:''})}>
                        <div className='bug-wrap' onClick={(e) => {e.stopPropagation()}}>
                            <img className='close_img' src={close_icon} alt='/' onClick={this.handleBugCloseClick}/>
                            <img className='back_img' src={this.state.path} alt='/'/>
                            <span>נציג פיפס זיהה: {this.state.bug_type}</span>
                        </div>
                    </div>
                </div>
                }
                {(!carDetails || Object.keys(this.loadedPhotos).length < (this.images_amount < 6 ? this.images_amount : 6)) &&
                    <Loader/>
                }
            </div>
        )
    }
}

export const PrevArrow = props => {
    const {currentSlide, slideCount, ...arrowProps} = props;
    return(
        <button type="button" {...arrowProps}>
            <img className='nextArrow rotate' src={arrowRight} alt='/' onClick={() => props.onArrowMove()}/>
        </button>
    );
}

export const NextArrow = props => {
    const {currentSlide, slideCount, ...arrowProps} = props;
    return(
        <button type="button" {...arrowProps}>
            <img className='nextArrow' src={arrowRight} alt='/' onClick={() => props.onArrowMove()}/>
        </button>
    );
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        carDetails: store.data.Car,
        text: store.config.Translations,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Basic);